export enum ProductName {
  NEW_STB_ATV = 'NEW_STB_ATV',
  UPGRADE_STB_ATV = 'UPGRADE_STB_ATV',
}
